import { useContext, useEffect, useState, useMemo } from 'react';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { GBENSContext } from '../GBENSContainer';

import Row from './_Row';

const TextAndSelectInput = ({
  id,
  screen,
  modal,
  consignment,
  item,
  name,
  type,
  toolTip,
  disabled,
  localErrors,
  rowProps,
  options = [],
  selectPlaceholder,
  textPlaceholder,
  selectId,
  textId,
}) => {
  const [localTextValue, setLocalTextValue] = useState('');

  const {
    currentConsignmentErrors,
    currentConsignment,
    data,
    updateData,
    errors,
    errorsLocal,
    updateCurrentConsignment,
    currentLine,
    updateCurrentLine,
  } = useContext(GBENSContext);

  //Calculate Error
  const modalGlobal = modal?.startsWith?.('_') ? modal.slice(1, modal.length) : modal;
  const _error = localErrors
    ? (errorsLocal?.[modalGlobal]?.[id] ?? null)
    : item
      ? (currentConsignmentErrors?.lines?.find?.((l) => l.id === currentLine.id)?.[id] ?? null)
      : consignment
        ? modal
          ? (currentConsignmentErrors?.[modalGlobal]?.[id] ?? null)
          : (currentConsignmentErrors?.[id] ?? null)
        : modal
          ? (errors?.[screen]?.[modalGlobal]?.[id] ?? null)
          : (errors?.[screen]?.[id] ?? null);

  //Calculate Value for Select Component
  const selectValue = item
    ? (currentLine?.[selectId] ?? '')
    : consignment
      ? modal
        ? (currentConsignment?.[modal]?.[selectId] ?? '')
        : (currentConsignment?.[selectId] ?? '')
      : modal
        ? (data?.[screen]?.[modal]?.[selectId] ?? '')
        : (data?.[screen]?.[selectId] ?? '');

  //Calculate Value
  const value = item
    ? (currentLine?.[textId] ?? '')
    : consignment
      ? modal
        ? (currentConsignment?.[modal]?.[textId] ?? '')
        : (currentConsignment?.[textId] ?? '')
      : modal
        ? (data?.[screen]?.[modal]?.[textId] ?? '')
        : (data?.[screen]?.[textId] ?? '');

  useEffect(() => {
    setLocalTextValue(value);
  }, [value]);

  //Calculate onChange function for Text and/or Select Component
  const handleDataChange = (e, fieldId) => {
    item
      ? updateCurrentLine(e, fieldId)
      : consignment
        ? updateCurrentConsignment(e, fieldId, modal)
        : updateData(e, screen, fieldId, modal);
  };

  const handleBlurTrimmed = (e) => {
    const newValue = e.target.value.trim();
    handleDataChange({ target: { ...e.target, value: newValue } }, textId);
  };

  // If using autocomplete, we need to create a 'fake' event object for the onChange
  const onAutocompleteChange = (e, selectedOption) => {
    const event = {
      target: {
        value: selectedOption?.value ?? '',
      },
    };
    handleDataChange(event, selectId);
  };

  // If using autocomplete, then the value for the component is different from the Select
  const autocompleteValue = useMemo(() => {
    const selectedOption = options?.find((opt) => opt.key == selectValue);
    return selectedOption ? { label: selectedOption.value, value: selectedOption.key } : null;
  }, [selectValue, options]);

  return (
    <Row
      name={name}
      warning={_error}
      toolTip={toolTip}
      rowProps={rowProps}
      component={
        <div style={{ display: 'flex', gap: 20 }}>
          <FormControl
            fullWidth
            sx={{
              flex: '1 1 0',
              '& .MuiInput-underline:before': {
                borderBottom: 'none !important', // Ensures underline is removed before focus
              },
              '& .MuiInput-underline:hover:before': {
                borderBottom: 'none !important', // Ensures underline is removed on hover
              },
              '& .MuiInput-underline:after': {
                borderBottom: 'none !important', // Ensures underline is removed after focus
              },
            }}
          >
            <Autocomplete
              variant="standard"
              value={autocompleteValue}
              onChange={onAutocompleteChange}
              options={options?.map((opt) => {
                return { label: opt.value, value: opt.key };
              })}
              renderInput={(params) => <TextField {...params} placeholder={selectPlaceholder || ' - Select - '} />}
              disabled={disabled}
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: 'flip',
                      options: {
                        rootBoundary: 'document',
                      },
                    },
                  ],
                },
              }}
            />
          </FormControl>
          <FormControl variant="standard" fullWidth sx={{ flex: '2 1 0' }}>
            <TextField
              fullWidth
              type={type}
              value={localTextValue}
              id={textId}
              onChange={(e) => {
                setLocalTextValue(e.target.value);
              }}
              onBlur={(e) => {
                handleBlurTrimmed(e, textId, modal);
              }}
              placeholder={textPlaceholder}
              disabled={disabled}
              autoComplete="off"
            />
          </FormControl>
        </div>
      }
    />
  );
};

export default TextAndSelectInput;
